<template>
  <CommonPopup
    @close="handleClose"
  >
    <AuthBlock />
  </CommonPopup>
</template>

<script setup lang='ts'>
import CommonPopup from '@common/components/popups/CommonPopup.vue';
import { usePopup } from '@common/composables/usePopup';
import AuthBlock from '@common/components/popups/auth/AuthBlock.vue';

const { closePopup } = usePopup();

const handleClose = () => {
  closePopup();
};
</script>

<style lang='scss' scoped>
.auth-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}
</style>
